module.exports = __webpack_public_path__ + "media/assets/images/bulloni_digitali/paolina-9393279739ab51151a646f6d0fd33509.jpg";